import type { ComponentType } from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  GitLabAccessLevelField,
  validateGitLabAccessLevel,
} from './GitLabAccessLevelField';

export const GitLabAccessLevelFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitLabAccessLevel',
    component: GitLabAccessLevelField,
    validation: validateGitLabAccessLevel,
  }),
) as unknown as ComponentType;
